import { useMutation } from "@tanstack/react-query";
import { ApiBalance } from "@/shared/api/balance/api-balance";
import { type CreateBalanceTopUp } from "@/shared/api/types";

const apiBalance = new ApiBalance();

export const useTopUpBalance = () => {
  return useMutation({
    mutationFn: (data: CreateBalanceTopUp) =>
      apiBalance.topUpBalance(data).then((res) => res.data),
    onError: (error) => {
      throw new Error("Top-up balance failed:", error);
    },
  });
};
